export const enum Names {
  LOCALE = "LOCALE",
  PROINDEX = "PROINDEX",

}
